export default "__VITE_ASSET__BDwnb_NS__"